import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewChildren } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { AppService } from 'src/app/core/services/app.service';
import { FormationComponent } from './formation.component';
import { QueryList } from '@angular/core/src/render3';

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import {AppConfigService} from "../../../../core/services/config.service";

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-formation-wrapper',
  template: `<div *ngIf="selectedRowData">
  <div class="card">
    <div class="card-body">
      <h2>
        <button class="btn btn-rounded pull-right close_button" placement="top" ngbTooltip="Fermer la fiche" (click)="onToggleFormation()">
          Fermer
        </button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button
                class="btn btn-rounded pull-right mr-2"
                placement="top"
                ngbTooltip="Exporter la fiche"
                style="background-color: #0C8B3E;color: #fff;"
                (click)="exportFiche()">
                <i class="ti-export"></i> &nbsp;
          Exporter
        </button>
      </h2>
      <br><br>
      <div class="row">
        <div class="col-lg-12">
          <div class="col-2 float-left">
            <h2 class="text-center">
              <img
                      src="assets/img/logo_sir.gif"
                      alt="LOGO SIR"
              />
            </h2>
          </div>
          <br /><br />
          <div class="col-9 text-center">
            <h2>
              <b>
                FORMULAIRE D'AIDE A L'ELABORATION DU CAHIER DES CHARGES FORMATION
              </b>
            </h2>
          </div>
          <div class="col-2 float-right" style="position: absolute;top:25%;right:0;font-size: 16px;">
            <h6>
              <b>
                Réf. : {{selectedRowData?.code}} <br>
                Rév. : 01 <br>
                Date : {{ selectedRowData?.updated_at }}<br>
                Page : 1 / 1
              </b>
            </h6>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-lg-12">
          <table class="table" style="border: none;">
            <tr>
              <td style="border: none;">
                <ul>
                  <li>
                    <label>
                      <b>Nom et Prénoms du demandeur :</b> &nbsp;&nbsp; <span style="color: #0075FF;"> <b>{{ selectedRowData?.demandeur[0]?.nom }} {{ selectedRowData?.demandeur[0]?.prenoms }}</b></span>
                    </label>
                  </li>
                </ul>
              </td>
              <td style="border: none;">
                <label><b>Fonction:</b> <span style="color: #0075FF;"> &nbsp;&nbsp;<b> {{  selectedRowData?.demandeur[0]?.poste?.libelle}} </b> </span></label>
              </td>
              <td style="border: none;">
                <label><b>Budget:</b> <span style="color: #0075FF;"> &nbsp;&nbsp;<b> {{  selectedRowData?.budget}} </b> </span></label>
              </td>
            </tr>
            <tr style="position: relative; top: -6%;">
              <td style="border: none;">
                <ul>
                  <li>
                    <label><b><u>Intitulé de la formation :</u></b> &nbsp;&nbsp; <span style="color: #0075FF;"> <b>{{ selectedRowData?.catalogue_formation?.libelle }}</b> </span></label>
                  </li>
                </ul>
              </td>
              <td style="border: none;">
                <label><b>Periode souhaitée:</b> <span style="color: #0075FF;"> &nbsp;&nbsp;<b> {{  selectedRowData?.date_debut }} <span class="text-dark">AU</span> {{  selectedRowData?.date_fin }} </b> </span></label>
              </td>
            </tr>
            <tr style="position: relative; top: -12%;">
              <td style="border: none;">
                <ul>
                  <li>
                    <label><b>Durée souhaitée (jours) :</b> &nbsp;&nbsp; <span style="color: #0075FF;"> <b>{{ selectedRowData?.duree_souhaite }} </b> </span></label>
                  </li>
                </ul>
              </td>
            </tr>
            <!-- <tr style="position: relative; top: -18%;">
              <td style="border: none;">
                <ul>
                  <li>
                    <label><b>Nombre de participants souhaité :</b>&nbsp; <span style="color: #0075FF;"> <b>{{ selectedRowData?.nombre_participant }}</b> </span></label>
                  </li>
                </ul>
              </td>
            </tr> -->
            <tr style="position: relative; top: -24%;">
              <td style="border: none;">
                <ul>
                  <li>
                    <label><b>Lieu de la formation :</b>&nbsp; <span style="color: #0075FF;"> <b>{{ selectedRowData?.lieu }}</b> </span></label>
                  </li>
                </ul>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <br><br>
      <div class="row" style="margin-top: -5%;">
        <div class="col-lg-12">
          <table class="table" style="border: 1px solid #000;">
            <thead style="background-color: #E5E5E5;color: #000;">
            <th style="vertical-align: middle;text-align: center;">
              <b>LISTE DES PARTICIPANTS</b> <br>(Nom et Prénoms)
            </th>
            <th style="vertical-align: middle;text-align: center;">
              <b>MOTIVATIONS DE LA DEMANDE DE FORMATION</b><br> (Raisons de la demande de la formation)
            </th>
            <th style="vertical-align: middle;text-align: center;">
              <b>COMPETENCES A DEVELOPPER</b><br> (Quelles compétences techniques, ou comportementales veut-on développer)
            </th>
            <th style="vertical-align: middle;text-align: center;">
              <b>MESURE DE L'EFFICACITE DE LA FORMATION</b><br> (Comment allez-vous évaluer l'efficacité de la formation ?)
            </th>
            </thead>
            <tbody>
            <tr>
              <td>
                    <ul>
                 <ng-container *ngIf="selectedRowData?.beneficiaires">
                    <li *ngFor="let beneficiaire of selectedRowData.beneficiaires">
                      {{ beneficiaire?.nom }} {{ beneficiaire?.prenoms }} <b>[{{ beneficiaire?.matricule }}]</b>
                    </li>
                  </ng-container>
                </ul>
              </td>
              <td>
                {{ selectedRowData?.motivation }}
              </td>
              <td>
                <ul>
                 <ng-container *ngIf="selectedRowData?.competences">
                  <ng-container *ngIf="isArray(selectedRowData.competences); else singleCompetence">
                    <li *ngFor="let c of selectedRowData.competences">
                      <b>{{ c?.code }}</b> {{ c?.libelle }}
                    </li>
                  </ng-container>
                  <ng-template #singleCompetence>
                    <li>
                      <b>{{ selectedRowData.competences?.code }}</b> {{ selectedRowData.competences?.libelle }}
                    </li>
                  </ng-template>
                </ng-container>
                </ul>
              </td>
              <td>
                {{ selectedRowData?.mesure_efficacite }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
      </div>`
})

export class FormationWrapperComponent {
  @Input() selectedRowData: any;
  @Output() toggleFormation = new EventEmitter<void>();
  public id_agent: any;
  public libelle_campagne: any;
  public nom: any;
  public prenoms: any;
  public matricule: any;
  public status_campagne: any;
  public poste: any;
  public listParticipant: any = [];
  public listCompetence: any = [];
  public API_URL: any;
  constructor(
    private configService: AppConfigService,
    private _service: AppService,
    private storage: LocalStorageService
  ) {
    this.API_URL = configService.get('HOST_API_ONLINE');
  }

  isArray(obj: any): boolean {
    return Array.isArray(obj);
  }

  onToggleFormation() {
    this.toggleFormation.emit();
  }

  // exportFiche() {
  //   window.open(`${this.API_URL}gestion-evaluations/formations/${this.selectedRowData.id}/normal/export-fiche-formation`, '_blank');
  // }

  getBase64ImageFromURL(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        const dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }

  async exportFiche(): Promise<void> {
    const logoImage = await this.getBase64ImageFromURL('assets/img/logo_sir.gif');

    const docDefinition = {
      // Ajoutez cette ligne pour définir l'orientation en paysage
      pageOrientation: 'landscape',

      // Ajustez les marges pour mieux utiliser l'espace en mode paysage
      pageMargins: [40, 40, 40, 40],
      content: [
        {
          columns: [
            {
              width: '20%',
              image: logoImage,
              fit: [100, 100] // Ajuste l'image dans un carré de 100x100
            },
            {
              width: '60%',
              text: 'FORMULAIRE D\'AIDE A L\'ELABORATION DU CAHIER DES CHARGES FORMATION',
              style: 'header',
              alignment: 'center',
              margin: [0, 20, 0, 0]
            },
            {
              width: '20%',
              text: [
                `Réf. : ${this.selectedRowData?.code}\n`,
                `Rév. : 01\n`,
                `Date : ${this.selectedRowData?.updated_at}\n`,
                'Page : 1 / 1'
              ],
              alignment: 'right',
              fontSize: 6
            }
          ]
        },
        { text: '\n\n' },
        {
          columns: [
            {
              text: [
                { text: 'Nom et Prénoms du demandeur : ', bold: true },
                { text: `${this.selectedRowData?.demandeur[0]?.nom} ${this.selectedRowData?.demandeur[0]?.prenoms}`, color: '#0075FF' }
              ]
            },
            {
              text: [
                { text: 'Fonction : ', bold: true },
                { text: `${this.selectedRowData?.demandeur[0]?.poste?.libelle}`, color: '#0075FF' }
              ]
            },
            {
              text: [
                { text: 'Budget : ', bold: true },
                { text: `${this.selectedRowData?.budget}`, color: '#0075FF' }
              ]
            }
          ]
        },
        { text: '\n' },

        {
          columns: [
            {
              text: [
                { text: 'Intitulé de la formation : ', bold: true },
                { text: `${this.selectedRowData?.catalogue_formation?.libelle}`, color: '#0075FF' }
              ]
            },
            {
              text: [
                { text: 'Periode souhaitée : ', bold: true },
                { text: `${this.selectedRowData?.date_debut} AU ${this.selectedRowData?.date_fin}`, color: '#0075FF' }
              ]
            },

          ]
        },
        { text: '\n' },
        {
          text: [
            { text: 'Durée souhaitée (jours) : ', bold: true },
            { text: `${this.selectedRowData?.duree_souhaite}`, color: '#0075FF' }
          ]
        },
        { text: '\n' },
        {
          text: [
            { text: 'Lieu de la formation : ', bold: true },
            { text: `${this.selectedRowData?.lieu}`, color: '#0075FF' }
          ]
        },
        { text: '\n\n' },
        {
          table: {
            headerRows: 1,
            widths: ['*', '*', '*', '*'],
            body: [
              [
                { text: 'LISTE DES PARTICIPANTS\n(Nom et Prénoms)', style: 'tableHeader' },
                { text: 'MOTIVATIONS DE LA DEMANDE DE FORMATION\n(Raisons de la demande de la formation)', style: 'tableHeader' },
                { text: 'COMPETENCES A DEVELOPPER\n(Quelles compétences techniques, ou comportementales veut-on développer)', style: 'tableHeader' },
                { text: 'MESURE DE L\'EFFICACITE DE LA FORMATION\n(Comment allez-vous évaluer l\'efficacité de la formation ?)', style: 'tableHeader' }
              ],
              [
                {
                  ul: this.selectedRowData?.beneficiaires.map(b => `${b.nom} ${b.prenoms} [${b.matricule}]`)
                },
                { text: this.selectedRowData?.motivation },
                {
                  ul: this.isArray(this.selectedRowData?.competences)
                    ? this.selectedRowData?.competences.map(c => `${c.code} ${c.libelle}`)
                    : [`${this.selectedRowData?.competences.code} ${this.selectedRowData?.competences.libelle}`]
                },
                { text: this.selectedRowData?.mesure_efficacite }
              ]
            ]
          }
        }
      ],
      styles: {
        header: {
          fontSize: 12,
          bold: true
        },
        tableHeader: {
          bold: true,
          fontSize: 8,
          color: 'black',
          fillColor: '#E5E5E5'
        }
      }
    };

    pdfMake.createPdf(docDefinition).open();
  }
}
